<template>
  <el-card>
    <el-row class="theme__title">主题配置</el-row>
    <!-- 搜索 -->
    <el-row class="theme__search">
      <span>主题名:</span>
      <el-input
        type="text"
        style="width: 200px"
        v-model="search.themeName"
        placeholder="搜索"
      />
      <span style="margin-left: 10px">状态:</span>
      <el-select
        v-model="search.valid"
        clearable
        filterable
        placeholder="请选择"
      >
        <el-option
          v-for="(item, index) in validList"
          :key="index"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button style="margin-left: 10px" type="primary" @click="getList"
        >搜索</el-button
      >
      <el-button
        style="margin-left: 10px"
        @click="
          () => {
            dialogType = 0
            isShow = true
          }
        "
        type="primary"
        >创建</el-button
      >
    </el-row>
    <!-- 表格 -->
    <el-table border :data="themeList">
      <el-table-column type="index"> </el-table-column>
      <el-table-column label="主题名" prop="themeName" align="center">
      </el-table-column>
      <el-table-column label="主题状态" align="center">
        <template slot-scope="scope">
          {{ scope.row.valid == 0 ? '无效' : '有效' }}
        </template>
      </el-table-column>
      <el-table-column prop="startTimeStr" label="开始时间" align="center">
        <!-- :formatter="formatDate" -->
      </el-table-column>
      <el-table-column prop="endTimeStr" label="结束时间" align="center">
      </el-table-column>
      <el-table-column prop="createTimeStr" label="创建时间" align="center">
      </el-table-column>
      <el-table-column prop="channel" label="渠道" align="center">
      </el-table-column>
      <el-table-column label="国家" align="center">
        <template slot-scope="scope">
          {{ scope.row.countryCodeList?.toString() || '' }}
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          {{ scope.row.valid == 1 ? '上架' : '下架' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button @click="change(scope.row, 1)" type="info"
            >更新配置</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 配置弹窗 -->
    <el-dialog
      @close="close"
      :visible.sync="isShow"
      :title="dialogType == 0 ? '创建' : '更新'"
    >
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="基本信息配置" name="first">
          <el-row>
            <span style="margin-right: 10px">主题平台:</span>
            <el-select
              v-model="form.clientSystem"
              clearable
              filterable
              placeholder="请选择"
              :disabled="dialogType == 0 ? false : true"
            >
              <el-option
                v-for="(item, index) in themeTabsList"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-row>
          <el-row>
            <span style="margin-right: 10px">渠道:</span>
            <el-select
              v-model="form.channel"
              style="width: 200px"
              filterable
              collapse-tags
              clearable
              placeholder="请选择"
              :disabled="dialogType == 0 ? false : true"
            >
              <el-option
                v-for="item in channelList"
                :key="item.channelId"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-row>
          <el-row>
            <span style="margin-right: 10px">主题名:</span>
            <el-input
              type="text"
              style="width: 200px"
              v-model="form.themeName"
              placeholder="请输入"
            />
          </el-row>
          <el-row>
            <span style="margin-right: 10px">国家:</span>
            <el-select
              style="width: 200px"
              v-model="form.countryCodeList"
              filterable
              multiple
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in countryList"
                :key="item.countryCode"
                :label="item.country"
                :value="item.countryCode"
              >
              </el-option>
            </el-select>
          </el-row>
          <el-row>
            <span style="margin-right: 10px">上下架时间:</span>
            <el-date-picker
              v-model="timer"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              value-format="yyyy-MM-dd hh:mm:ss"
              @change="changeContractPeriod"
            >
            </el-date-picker>
          </el-row>
          <el-row>
            <span style="margin-right: 10px">状态:</span>
            <el-switch
              v-model="form.valid"
              active-text="有效"
              inactive-text="无效"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="底部Tab栏配置" name="second">
          <!-- tab -->
          <el-row
            style="
              display: flex;
              gap: 10px;
              border: 1px dotted #ccc;
              padding: 10px;
              border-radius: 10px;
            "
          >
            <span>tab栏图标：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 0, 0)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.tabIcon"
                :src="form.detailData.tabIcon"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span>tab栏选中：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 0, 1)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.selectCursorIcon"
                :src="form.detailData.selectCursorIcon"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-row>
          <!-- live -->
          <el-row
            style="
              display: flex;
              gap: 10px;
              border: 1px dotted #ccc;
              padding: 10px;
              border-radius: 10px;
            "
          >
            <span>live未选中：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 1, 0)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.liveNotSelect"
                :src="form.detailData.liveNotSelect"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span>live选中：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 1, 1)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.liveSelect"
                :src="form.detailData.liveSelect"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-row>
          <!-- party -->
          <el-row
            style="
              display: flex;
              gap: 10px;
              border: 1px dotted #ccc;
              padding: 10px;
              border-radius: 10px;
            "
          >
            <span>party未选中：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 2, 0)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.partyNotSelect"
                :src="form.detailData.partyNotSelect"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span>party选中：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 2, 1)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.partySelect"
                :src="form.detailData.partySelect"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-row>
          <!-- community -->
          <el-row
            style="
              display: flex;
              gap: 10px;
              border: 1px dotted #ccc;
              padding: 10px;
              border-radius: 10px;
            "
          >
            <span>community未选中：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 3, 0)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.communityNotSelect"
                :src="form.detailData.communityNotSelect"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span>community选中：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 3, 1)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.communitySelect"
                :src="form.detailData.communitySelect"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-row>
          <!-- message -->
          <el-row
            style="
              display: flex;
              gap: 10px;
              border: 1px dotted #ccc;
              padding: 10px;
              border-radius: 10px;
            "
          >
            <span>message未选中：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 4, 0)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.messageNotSelect"
                :src="form.detailData.messageNotSelect"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span>message选中：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 4, 1)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.messageSelect"
                :src="form.detailData.messageSelect"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-row>
          <!-- me -->
          <el-row
            style="
              display: flex;
              gap: 10px;
              border: 1px dotted #ccc;
              padding: 10px;
              border-radius: 10px;
            "
          >
            <span>me未选中：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 5, 0)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.meNotSelect"
                :src="form.detailData.meNotSelect"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span>me选中：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 5, 1)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.meSelect"
                :src="form.detailData.meSelect"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="其他配置" name="third">
          <!-- 背景图 -->
          <el-row
            style="
              display: flex;
              gap: 10px;
              border: 1px dotted #ccc;
              padding: 10px;
              border-radius: 10px;
              margin-bottom: 10px;
            "
          >
            <span>背景图：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 6, 0)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.backgroundIcon"
                :src="form.detailData.backgroundIcon"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-row>
          <!-- 筛选栏色值 -->
          <el-row style="margin-bottom: 10px">
            <span style="margin-right: 10px">筛选栏色值：</span>
            <el-input
              type="text"
              style="width: 200px"
              v-model="form.detailData.filterBarColor"
              placeholder="请输入色值（如：#FFFFFF）"
            />
          </el-row>
          <!-- 筛选栏未选中色值 -->
          <el-row style="margin-bottom: 10px">
            <span style="margin-right: 10px">筛选栏未选中色值：</span>
            <el-input
              type="text"
              style="width: 200px"
              v-model="form.detailData.filterBarColorNotSelect"
              placeholder="请输入色值（如：#CCCCCC）"
            />
          </el-row>
          <!-- 顶部字体选中色值 -->
          <el-row style="margin-bottom: 10px">
            <span style="margin-right: 10px">顶部字体选中色值：</span>
            <el-input
              type="text"
              style="width: 200px"
              v-model="form.detailData.colorSelect"
              placeholder="请输入色值（如：#FF0000）"
            />
          </el-row>
          <!-- 顶部字体未选中色值 -->
          <el-row style="margin-bottom: 10px">
            <span style="margin-right: 10px">顶部字体未选中色值：</span>
            <el-input
              type="text"
              style="width: 200px"
              v-model="form.detailData.colorNotSelect"
              placeholder="请输入色值（如：#666666）"
            />
          </el-row>
          <!-- 搜索图标 -->
          <el-row
            style="
              display: flex;
              gap: 10px;
              border: 1px dotted #ccc;
              padding: 10px;
              border-radius: 10px;
              margin-bottom: 10px;
            "
          >
            <span>搜索图标：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 6, 1)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.searchIcon"
                :src="form.detailData.searchIcon"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-row>
          <!-- 消息清理图标 -->
          <el-row
            style="
              display: flex;
              gap: 10px;
              border: 1px dotted #ccc;
              padding: 10px;
              border-radius: 10px;
              margin-bottom: 10px;
            "
          >
            <span>消息清理图标：</span>
            <el-upload
              class="avatar-uploader"
              action="#"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="
                (file, fileList) =>
                  changfile(file, fileList, 'theme/icon/', 6, 2)
              "
              :auto-upload="false"
            >
              <img
                v-if="form.detailData.clearMsgIcon"
                :src="form.detailData.clearMsgIcon"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-row>
          <!-- 飘屏列表 -->
          <el-row style="margin-bottom: 10px">
            <div style="width: 100%">
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px">
                <span style="font-weight: 600">飘屏列表：</span>
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-plus"
                  @click="addFloatScreenItem"
                >添加飘屏项</el-button>
              </div>
              <el-table
                :data="form.detailData && form.detailData.floatScreenList ? form.detailData.floatScreenList : []"
                border
                style="width: 100%"
                max-height="400"
              >
                <el-table-column type="index" label="序号" width="60" align="center">
                </el-table-column>
                <el-table-column label="飘屏图片" align="center">
                  <template slot-scope="scope">
                    <el-upload
                      class="avatar-uploader-small"
                      action="#"
                      list-type="picture-card"
                      :show-file-list="false"
                      :on-change="
                        (file, fileList) =>
                          changfile(file, fileList, 'theme/icon/', 7, scope.$index)
                      "
                      :auto-upload="false"
                    >
                      <img
                        v-if="scope.row.url"
                        :src="scope.row.url"
                        class="avatar-small"
                      />
                      <i v-else class="el-icon-plus avatar-uploader-icon-small"></i>
                    </el-upload>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template slot-scope="scope">
                    <el-button
                      type="danger"
                      size="mini"
                      icon="el-icon-delete"
                      @click="removeFloatScreenItem(scope.$index)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <el-row>
        <el-button type="primary" @click="close">关闭</el-button>
        <el-button type="primary" @click="add">{{
          dialogType == 0 ? '创建' : '更新'
        }}</el-button>
      </el-row>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      themeList: [],
      themeTabsList: [],
      countryList: [],
      channelList: [],
      activeName: 'first',
      clientSystem: null,
      dialogType: 0, //0 创建 1 更新
      isShow: false,
      timer: null,
      validList: [
        {
          name: 'all',
          value: null,
        },
        {
          name: '无效',
          value: 0,
        },
        {
          name: '有效',
          value: 1,
        },
      ],
      search: {
        themeName: null,
        valid: null,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      form: {
        themeName: null,
        channel: null,
        countryCodeList: null,
        valid: 1,
        startTimeStr: null,
        endTimeStr: null,
        detailData: {
          tabIcon: null,
          selectCursorIcon: null,
          liveSelect: null,
          liveNotSelect: null,
          partySelect: null,
          partyNotSelect: null,
          communitySelect: null,
          communityNotSelect: null,
          messageSelect: null,
          messageNotSelect: null,
          meSelect: null,
          meNotSelect: null,
          backgroundIcon: null,
          filterBarColor: null,
          filterBarColorNotSelect: null,
          colorSelect: null,
          colorNotSelect: null,
          searchIcon: null,
          clearMsgIcon: null,
          floatScreenList: [],
        },
      },
    }
  },
  mounted() {
    this.getAll()
  },
  methods: {
    getAll() {
      this.getTabs()
      this.getList()
      this.getChannel()
      this.getCountryCode()
    },

    // 格式化时间
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property] * 1000
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
    // 获取渠道选项
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelList = [
          { channelId: -1, name: 'all', value: 'all' },
          ...res.data,
        ]
      }
    },
    changeContractPeriod(value) {
      this.form.startTimeStr = value[0] + '.000'
      this.form.endTimeStr = value[1] + '.000'
    },
    // 获取国家选项
    async getCountryCode() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.normal_country +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.countryList = res.data.countryList
      }
    },
    // 获取配置常量
    async getTabs() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url:
          this.$store.getters.path.config_theme_tab +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.themeTabsList = res.data
      }
    },
    // 获取列表
    async getList() {
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.config_theme_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          ...this.search,
        },
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.themeList = res.data
        console.log(this.themeList)
      }
    },
    add() {
      if (
        this.form.countryCodeList &&
        Array.isArray(this.form.countryCodeList) &&
        this.form.countryCodeList.findIndex(
          (item) => item == 'total' || item == 'all'
        ) != -1
      ) {
        this.form.countryCodeList = this.countryList
          .filter(
            (item) => item.countryCode != 'total' && item.countryCode != 'all'
          )
          .map((item) => item.countryCode)
      }
      // 转换 floatScreenList 为字符串数组格式（后端期望 array[string]）
      if (this.form.detailData && this.form.detailData.floatScreenList && Array.isArray(this.form.detailData.floatScreenList)) {
        const submitData = { ...this.form }
        submitData.detailData = {
          ...this.form.detailData,
          floatScreenList: this.form.detailData.floatScreenList
            .map(item => {
              if (typeof item === 'string') {
                return item
              }
              return item && item.url ? item.url : ''
            })
            .filter(url => url) // 过滤掉空字符串
        }
        if (this.dialogType == 0) {
          this.createWithData(submitData)
        } else {
          this.editWithData(submitData)
        }
      } else {
        if (this.dialogType == 0) {
          this.create()
        } else {
          this.edit()
        }
      }
    },
    change(info, type) {
      this.dialogType = 1
      this.form = JSON.parse(JSON.stringify(info))
      this.form.startTimeStr = this.form.startTimeStr + '.000'
      this.form.endTimeStr = this.form.endTimeStr + '.000'
      // 确保 detailData 存在
      if (!this.form.detailData) {
        this.$set(this.form, 'detailData', {})
      }
      // 确保 floatScreenList 存在且是数组
      if (!this.form.detailData.floatScreenList || !Array.isArray(this.form.detailData.floatScreenList)) {
        this.$set(this.form.detailData, 'floatScreenList', [])
      } else {
        // 如果存在但是字符串数组，转换为对象数组
        const list = this.form.detailData.floatScreenList
        if (list.length > 0 && typeof list[0] === 'string') {
          this.$set(this.form.detailData, 'floatScreenList', list.map(url => ({ url: url || '' })))
        } else {
          // 确保每个项都有 url 属性
          this.$set(this.form.detailData, 'floatScreenList', list.map(item => {
            if (typeof item === 'string') {
              return { url: item }
            }
            return item && item.url ? item : { url: '' }
          }))
        }
      }
      if (type == 0) {
        this.form.valid = Math.abs(this.form.valid - 1)
        this.edit()
      } else {
        this.timer = [this.form.startTimeStr, this.form.endTimeStr]
        this.isShow = true
      }
    },
    // 创建
    async create() {
      await this.createWithData(this.form)
    },
    // 创建（带数据）
    async createWithData(data) {
      const { data: res } = await this.$axios({
        method: 'POSt',
        url: this.$store.getters.path.config_theme_add,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: data,
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.close()
        this.getList()
      }
    },
    // 更新
    async edit() {
      await this.editWithData(this.form)
    },
    // 更新（带数据）
    async editWithData(data) {
      const { data: res } = await this.$axios({
        method: 'POSt',
        url: this.$store.getters.path.config_theme_edit,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
        data: data,
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.close()
        this.getList()
      }
    },
    //上传图片
    async changfile(file, fileList, dir, type, types) {
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      formdata.append('dir', dir)
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        formdata
      )

      if (res.code !== 0) {
        this.fileList = []
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      if (type == 0) {
        if (types == 0) {
          this.form.detailData.tabIcon = res.data
        } else {
          this.form.detailData.selectCursorIcon = res.data
        }
      } else if (type == 1) {
        if (types == 0) {
          this.form.detailData.liveNotSelect = res.data
        } else {
          this.form.detailData.liveSelect = res.data
        }
      } else if (type == 2) {
        if (types == 0) {
          this.form.detailData.partyNotSelect = res.data
        } else {
          this.form.detailData.partySelect = res.data
        }
      } else if (type == 3) {
        if (types == 0) {
          this.form.detailData.communityNotSelect = res.data
        } else {
          this.form.detailData.communitySelect = res.data
        }
      } else if (type == 4) {
        if (types == 0) {
          this.form.detailData.messageNotSelect = res.data
        } else {
          this.form.detailData.messageSelect = res.data
        }
      } else if (type == 5) {
        if (types == 0) {
          this.form.detailData.meNotSelect = res.data
        } else {
          this.form.detailData.meSelect = res.data
        }
      } else if (type == 6) {
        if (types == 0) {
          this.form.detailData.backgroundIcon = res.data
        } else if (types == 1) {
          this.form.detailData.searchIcon = res.data
        } else if (types == 2) {
          this.form.detailData.clearMsgIcon = res.data
        }
      } else if (type == 7) {
        // 飘屏列表上传，types 是索引
        if (this.form.detailData.floatScreenList && this.form.detailData.floatScreenList[types]) {
          this.$set(this.form.detailData.floatScreenList[types], 'url', res.data)
        }
      }
    },
    // 删除图片
    handleRemove(type, types) {
      if (type == 0) {
        if (types == 0) {
          this.form.detailData.tabIcon = null
        } else {
          this.form.detailData.selectCursorIcon = null
        }
      } else if (type == 1) {
        if (types == 0) {
          this.form.detailData.liveNotSelect = null
        } else {
          this.form.detailData.liveSelect = null
        }
      } else if (type == 2) {
        if (types == 0) {
          this.form.detailData.partyNotSelect = null
        } else {
          this.form.detailData.partySelect = null
        }
      } else if (type == 3) {
        if (types == 0) {
          this.form.detailData.communityNotSelect = null
        } else {
          this.form.detailData.communitySelect = null
        }
      } else if (type == 4) {
        if (types == 0) {
          this.form.detailData.messageNotSelect = null
        } else {
          this.form.detailData.messageSelect = null
        }
      } else if (type == 5) {
        if (types == 0) {
          this.form.detailData.meNotSelect = null
        } else {
          this.form.detailData.meSelect = null
        }
      }
    },
    // 关闭弹窗
    close() {
      console.log('close')
      this.timer = null
      this.form = {
        themeName: null,
        channel: null,
        countryCodeList: null,
        valid: 1,
        startTimeStr: null,
        endTimeStr: null,
        detailData: {
          tabIcon: null,
          selectCursorIcon: null,
          liveSelect: null,
          liveNotSelect: null,
          partySelect: null,
          partyNotSelect: null,
          communitySelect: null,
          communityNotSelect: null,
          messageSelect: null,
          messageNotSelect: null,
          meSelect: null,
          meNotSelect: null,
          backgroundIcon: null,
          filterBarColor: null,
          filterBarColorNotSelect: null,
          colorSelect: null,
          colorNotSelect: null,
          searchIcon: null,
          clearMsgIcon: null,
          floatScreenList: [],
        },
      }
      this.activeName = 'first'
      this.isShow = false
    },
    // 添加飘屏项
    addFloatScreenItem() {
      if (!this.form.detailData) {
        this.$set(this.form, 'detailData', {})
      }
      if (!this.form.detailData.floatScreenList || !Array.isArray(this.form.detailData.floatScreenList)) {
        this.$set(this.form.detailData, 'floatScreenList', [])
      }
      // 使用 $set 添加新项，确保响应式，添加对象格式 { url: '' }
      const newIndex = this.form.detailData.floatScreenList.length
      this.$set(this.form.detailData.floatScreenList, newIndex, { url: '' })
    },
    // 删除飘屏项
    removeFloatScreenItem(index) {
      if (this.form.detailData && this.form.detailData.floatScreenList && Array.isArray(this.form.detailData.floatScreenList)) {
        this.form.detailData.floatScreenList.splice(index, 1)
        // 强制触发视图更新
        this.$forceUpdate()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.theme {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}

.avatar-uploader {
  margin: 10px 0;
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
}

.avatar-uploader-small {
  margin: 10px 0;
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon-small {
    font-size: 20px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar-small {
    width: 100px;
    height: 100px;
    display: block;
  }
}
</style>
